import React, {FC, useEffect, useMemo, useState} from "react";
import {transactionService} from "../../../store/actions";
import {Link, useParams} from "react-router-dom";
import useCommon from "../../../common/hooks/useCommon";
import {formatTimestamp, formatUnit, getFiat, getTimeLang, serializeQuery, toXDCNumber, truncate,} from "../../../common/utils/function";
import BTable from "../../../components/b-table";
import AddressName from "../address-name";
import {useTranslation} from "react-i18next";
import BCopy from "../../../components/b-copy";

interface InternalTransactionAccountListProps {
    count?: number;
}

interface TransactionListData {
    transaction_hash: string;
    block: number;
    timestamp: string | number;
    type: any;
    from: any;
    to: any;
    value: string | number;
    gas_price: string | number;
}

const InternalTransactionList: FC<InternalTransactionAccountListProps> = (
    props
) => {
    const {hash} = useParams();
    const {getTime, getXDC, get0x} = useCommon();
    const {t, i18n} = useTranslation();
    const [isUTC, setIsUTC] = useState(false);
    const [isValue, setIsValue] = useState(false);

    const [transactionList, setTransactionList] = useState<TransactionListData[]>([]);
    const [loading, setLoading] = useState(true);
    const [pageParams, setPageParams] = useState<any>([null])
    const [pageIndex, setPageIndex] = useState<any>(0)
    const getBlocks = async () => {
        try {
            setLoading(true);
            transactionService.getInternalTransaction(hash, serializeQuery(pageParams[pageIndex])).then(response => {
                setTransactionList(response?.items)
                setPageParams((prevState: any) => {
                    prevState[pageIndex + 1] = response?.next_page_params
                    return prevState
                })
                setLoading(false);
            }).catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getBlocks();
    }, [pageIndex, isUTC])
    const handleButtonClick = () => {
        setIsUTC(!isUTC);
    };

    const header = useMemo(() => {
        return [
            {
                title: `${t("Tx Hash")}`,
                param: 'name',
                tooltip: (data: any) => <Link to={`/tx/${get0x(data?.transaction_hash)}`}>{get0x(data?.transaction_hash)}</Link>,
                render: (data: any) => <Link to={`/tx/${get0x(data?.transaction_hash)}`}>   {truncate(get0x(data?.transaction_hash))}
                    &nbsp;<BCopy value={get0x(data?.transaction_hash)} tooltip={`${t("Transaction Hash")}`}/></Link>
            },
            {
                title: `${t("Block")}`,
                param: 'quantity',
                tooltip: true,
                render: (data: any) => <Link to={`/block/${data?.block}`}>{data?.block}</Link>
            },
            {
                title: (<a href="javascript:" onClick={handleButtonClick} data-bs-trigger="hover">{isUTC ? t("Date Time (UTC)") : t("Age")}</a>),
                param: 'quantity',
                tooltip: (data: any) => isUTC ? getTimeLang(data?.timestamp, t) : formatTimestamp(data?.timestamp),
                render: (data: any) => isUTC ? formatTimestamp(data?.timestamp) : getTimeLang(data?.timestamp, t),
            },
            {
                title: `${t("From")}`,
                param: 'quantity',
                headerStyle: {minWidth: "130px"},
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.from?.hash)}`}>{getXDC(data?.from?.hash)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.from?.hash)}`}><AddressName data={data?.from}/></Link>
            },
            {
                title: `${t("To")}`,
                param: 'quantity',
                headerStyle: {minWidth: "130px"},
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.to?.hash)}`}>{getXDC(data?.to?.hash)}</Link>,
                render: (data: any) => <Link to={`/address/${get0x(data?.to?.hash)}`}><AddressName data={data?.to}/></Link>
            },
            {
                title: (<a href="javascript:" onClick={() => setIsValue(!isValue)}data-bs-trigger="hover"> {isValue ? t("Amount") : t("Value (USD)")}</a>),
                param: 'quantity',
                headerStyle: {minWidth: "130px"},
                tooltip: true,
                render: (data: any) =>
                <span onClick={() => setIsValue(!isValue)}>
                    {isValue  ?  formatUnit(toXDCNumber(data?.value, 18)) : getFiat((toXDCNumber(data?.value, 18)), 4)}
                </span>,
                    // `${data?.value} ${process.env.REACT_APP_BASE_UNIT}`
            },
        ]
    }, [isUTC])
    return <BTable
        title={<React.Fragment>
      <p className="mb-0 font-b"> <i className="bi bi-sort-down me-1"></i>
        Latest 25 internal transactions (View All) <br/>
      </p>
        </React.Fragment>}
        header={header}
        list={transactionList}
        loading={loading}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
    />;
}

export default InternalTransactionList;
